import { Component } from '@angular/core';

@Component({
  selector: 'mtg-icons',
  templateUrl: './icons.component.html',
})
export class IconsComponent {}
